var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlideArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-4.83 -4.83 58.00 58.00",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.3534640000000002
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M26.436,2.3c-1.253-3.067-3.285-3.067-4.539,0l-7.654,18.739c-1.254,3.067-0.212,4.359,2.327,2.884 l2.867-1.666c0.955-0.555,1.428-0.158,1.221,0.927c-0.355,1.866-0.727,5.212-0.491,10.592c-0.099,4.477,0.316,8.115,0.642,10.216 c0.169,1.091,0.317,2.956,1.001,3.823c0.549,0.697,4.166,0.697,4.715,0c0.684-0.867,0.766-2.742,0.896-3.838 c0.285-2.396,0.713-6.558,0.747-10.201c0.052-5.459-0.273-8.746-0.567-10.574c-0.175-1.09,0.342-1.5,1.297-0.945 c0.786,0.457,1.784,1.036,2.869,1.666c2.539,1.475,3.582,0.184,2.328-2.884L26.436,2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M26.436,2.3c-1.253-3.067-3.285-3.067-4.539,0l-7.654,18.739c-1.254,3.067-0.212,4.359,2.327,2.884 l2.867-1.666c0.955-0.555,1.428-0.158,1.221,0.927c-0.355,1.866-0.727,5.212-0.491,10.592c-0.099,4.477,0.316,8.115,0.642,10.216 c0.169,1.091,0.317,2.956,1.001,3.823c0.549,0.697,4.166,0.697,4.715,0c0.684-0.867,0.766-2.742,0.896-3.838 c0.285-2.396,0.713-6.558,0.747-10.201c0.052-5.459-0.273-8.746-0.567-10.574c-0.175-1.09,0.342-1.5,1.297-0.945 c0.786,0.457,1.784,1.036,2.869,1.666c2.539,1.475,3.582,0.184,2.328-2.884L26.436,2.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideArrow);
export default __webpack_public_path__ + "static/media/slide-arrow.f52efbbda2e45636e076ec65648b7d76.svg";
export { ForwardRef as ReactComponent };